<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>{{ title }}</h3>
            </div>
        </div>
        <vs-table
            ref="tableSelect"
            search
            :max-items="maximoItems == ''?20:maximoItems"
            :data="registros"
            pagination
        >
            <template slot="header">
            <div class="form-inline">
                <input-field  
                class="input-field--stretch ml-3"
                type="tel" 
                v-mask="'###'"
                v-model="maximoItems"
                id="maximoItems"
                placeholder
                >
                    <span>Cantidad de registros:</span>
                </input-field>
                <label for="seleccionados">
                    <strong>{{ seleccionados.length }} registro(s) seleccionado(s).</strong>
                </label>
            </div>
            </template>
            <template slot="thead">
                <vs-th>
                    <div>
                        <label for="seleccionar_todos">
                            <input @change="changeSeleccionarTodos" type="checkbox" name="seleccionar_todos" id="seleccionar_todos" v-model="seleccionar_todos"><span><br></span>
                        </label>
                    </div>
                </vs-th>
                <vs-th
                    :sort-key="columna.sortable?columna.nombre:null"
                    v-for="columna in columnas"
                    v-show="!columna.hidden"
                    :key="columna.nombre"
                >
                    {{ columna.descripcion }}
                </vs-th>
            </template>
            <template slot-scope="{ data }">
                <vs-tr
                    :data="tr"
                    :key="index"
                    v-for="(tr, index) in data"
                >
                    <vs-td>
                        <div>
                            <label :for="'seleccionar' + index">
                                <input type="checkbox" v-model="seleccionados" :value="tr" :id="'seleccionar' + index"><span></span>
                            </label>
                        </div>
                    </vs-td>
                    <vs-td v-show="!columna.hidden" :data="lodash.get(data[index], columna.nombre)" v-for="columna in columnas" :key="columna.nombre + index">
                        <span v-if="saldoSeleccionable && columna.nombre == columnaPago && seleccionados.includes(tr)">
                            <div class="form-field">
                                <input-field @input="validarSaldo(index)" :id="columna.nombre + index" placeholder="Seleccione..." vMoney :format="money" v-model="data[index][columna.nombre]"></input-field>
                            </div>
                        </span>
                        <span v-else-if="columna.link">
                            <button @click="$emit('visitarLink', data[index], columna.nombre)" class="btn-info btn--text" type="button">
                                <span>{{ lodash.get(data[index], columna.nombre) }}</span>
                            </button>
                        </span>
                        <span v-else>
                            {{ columna.money?moneyFormat(lodash.get(data[index], columna.nombre)):lodash.get(data[index], columna.nombre) }}
                        </span>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <div class="modal-buttons">
            <button type="button" @click="seleccionar" class="btn-success"><i class="fa fa-check"></i><span>Seleccionar</span></button>
            <button @click="cerrar" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        cargaAutomatica: {
            type: Boolean,
            required: false,
            default: true
        },
        columnaSaldo: {
            type: String,
            required: false,
            default: 'saldo'
        },
        columnaPago: {
            type: String,
            required: false,
            default: 'valor_pago'
        },
        saldoSeleccionable: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: 'Seleccione uno o varios registros...'
        },
        keys: {
            type: Array,
            required: false,
            default: function () {
                return ['id'];
            }
        },
        params: {
            type: Object,
            required: false,
            default: function () {
                return {};
            }
        },
        columnas: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        urlConsulta: {
            type: String,
            required: false,
            default: ''
        },
        value: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        columnaSaldo: {
            type: String,
            required: false,
            default: 'saldo'
        }
    },
    data: function () {
        return {
            money: money,
            registros: [],
            form: {
                search: ''
            },
            seleccionados: [],
            maximoItems: 20,
            lodash: _,
            moneyFormat: moneyFormat,
            modelValue: this.value,
            seleccionar_todos: false
        };
    },
    methods: {
        seleccionarTodosManualmente: function () {
            this.seleccionar_todos = true;
            this.changeSeleccionarTodos();
        },
        validarSaldo: function (index) {
            let saldo = parseFloat(this.registros[index][this.columnaSaldo]);
            if (isNaN(saldo))
                saldo = 0;
            let valorPago = parseFloat(this.registros[index][this.columnaPago]);
            if (isNaN(valorPago))
                valorPago = 0;
            if (valorPago > saldo) {
                this.registros[index][this.columnaPago] = saldo;
            }
        },
        changeSeleccionarTodos: function () {
            this.seleccionados.splice(0, this.seleccionados.length);
            if (this.seleccionar_todos) {
                for (let i = 0; i < this.registros.length; i++) {
                    this.seleccionados.push(this.registros[i]);
                }
            }
        },
        seleccionar: function () {
            this.$emit('seleccionar', this.seleccionados);
        },
        cerrar: function () {
            this.$emit('cerrar');
        },
        consultar: function (seleccionarTodos = false) {
            let form = this.form;
            let params = this.params;
            let finalForm = {...form, ...params};
            axios.get(this.urlConsulta, {
                params: finalForm
            }).then(({data}) => {
                this.registros = data;
                if (this.modelValue.length == 0 && seleccionarTodos) {
                    this.seleccionarTodosManualmente();
                }
                else {
                    for (let i = 0; i < this.modelValue.length; i++) {
                        for (let j = 0; j < this.registros.length; j++) {
                            let valido = true;
                            for (let k = 0; k < this.keys.length; k++) {
                                if (this.modelValue[i][this.keys[k]] != this.registros[j][this.keys[k]]) {
                                    valido = false;
                                    break;
                                }
                            }
                            if (valido) 
                            {
                                let selected = this.registros[j];
                                if (this.saldoSeleccionable) {
                                    let valor = parseFloat(this.modelValue[i][this.columnaPago]);
                                    if (valor < 0)
                                        valor = valor * -1;
                                    selected[this.columnaPago] = valor;
                                    let saldo = parseFloat(this.modelValue[i][this.columnaSaldo]);
                                    saldo+= valor;
                                    selected[this.columnaSaldo] = round(saldo, 2);
                                }
                                this.seleccionados.push(selected);
                            }
                        }
                    }
                }
            }).catch(() => {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        }
    },
    mounted: function () {
        if (this.cargaAutomatica)
            this.consultar();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/KTableSelect.vue